module.exports = __webpack_public_path__ + "static/media/testimonial1.7a02797f.png";